import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import InfoCountryIcon from '@/modules/Statistics/assets/icons/info-circle-country.svg?react';
import InfoProvinceIcon from '@/modules/Statistics/assets/icons/info-circle-province.svg?react';
import WhiteStar from '@/modules/Statistics/assets/icons/WhiteStar.svg?react';
import { useState } from 'react';
import { Box, Center, Flex } from 'styled-system/jsx';
import { GetAdjusterRankQueryResponseType } from '../../queries/getAdjusterRank/getAdjusterRankQuery.type';

export default function MyRanking({
  MyRankingData,
  isProvince,
  isLoading,
}: {
  MyRankingData?: GetAdjusterRankQueryResponseType;
  isProvince: boolean;
  isLoading?: boolean;
}) {
  const [open, setIsOpen] = useState(false);

  const handleToggleToolTip = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  if (isLoading) {
    return <LoadingPage height="14vh" />;
  }

  const myRank = MyRankingData?.[0];
  const rankColor = isProvince ? '#277A9D' : 'purple-primary';

  return (
    <Flex
      borderRadius="8px"
      padding="16px"
      bg="purple-6"
      justifyContent="space-between"
      alignItems="center"
      position="relative"
    >
      <Flex gap="16px" alignItems="center">
        <Center
          width="48px"
          height="48px"
          borderRadius="999px"
          border="1px solid"
          borderColor={rankColor}
          flexShrink={0}
        >
          <Typography textStyle="b1" color={rankColor}>
            {isProvince ? myRank?.province_rank : myRank?.national_rank}
          </Typography>
        </Center>

        <Box>
          <Flex alignItems="center" gap="6px">
            <Typography textStyle="b2" color={rankColor}>
              رتبه من
            </Typography>

            <Box
              position="relative"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
            >
              {isProvince ? (
                <InfoProvinceIcon onClick={handleToggleToolTip} />
              ) : (
                <InfoCountryIcon onClick={handleToggleToolTip} />
              )}

              {open && (
                <Box
                  position="absolute"
                  bottom="calc(100% + 8px)"
                  left="50%"
                  transform="translateX(-50%)"
                  width="max-content"
                  maxWidth="min(280px, calc(100vw - 32px))"
                  backgroundColor="#1B1B1B"
                  borderRadius="8px"
                  padding="20px"
                  zIndex={100}
                  boxShadow="0 4px 12px rgba(0, 0, 0, 0.3)"
                  cursor="default"
                  animation="fadeInTooltip 0.2s ease-out forwards"
                  onClick={(e) => e.stopPropagation()}
                  _after={{
                    content: '""',
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderTop: '6px solid #1B1B1B',
                  }}
                >
                  <Typography
                    textStyle="b1"
                    color="white"
                    textAlign="center"
                    lineHeight="1.5"
                  >
                    این امتیاز برای رتبه‌بندی محاسبه شده و ممکن است با امتیاز
                    عملکرد شما متفاوت باشد.
                  </Typography>
                </Box>
              )}
            </Box>
          </Flex>

          <Typography color="black" mt="4px">
            {myRank?.adjuster?.full_name}
          </Typography>
        </Box>
      </Flex>

      <Flex
        borderRadius="8px"
        py="4px"
        px="8px"
        gap="6px"
        alignItems="center"
        bg={rankColor}
        flexShrink={0}
      >
        <Typography color="white">{myRank?.weighted_score}</Typography>
        <WhiteStar />
      </Flex>
    </Flex>
  );
}
